import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {SaleProductModel} from "../../../api/entity/saleProduct.model";
import {SaleDeleteProductActionService} from "../../../../../impl/service/saleDeleteProductAction.service";
import {SaleDeleteProductActionPayload} from "../../../../../impl/service/payload/action/saleDeleteProductAction.payload";
import {DialogController} from "../../../../../../common/dialog/dialogController";
import {
    ProductUpdatePriceDialogInput, ProductUpdatePriceDialogOutput,
    SaleProductUpdatePriceDialogComponent
} from "../sale-product-update-price-dialog/sale-product-update-price-dialog.component";

@Component({
    selector: 'app-sale-product-card-row',
    templateUrl: './sale-product-card-row.component.html',
    styleUrls: ['./sale-product-card-row.component.scss'],
    viewProviders: [SaleDeleteProductActionService]
})
export class SaleProductCardRowComponent implements OnInit {

    @Input() entity: SaleProductModel;
    @Input() saleId: number;

    @Output() productDeletedEvent: EventEmitter<SaleProductModel> = new EventEmitter<SaleProductModel>();
    @Output() priceUpdatedEvent: EventEmitter<SaleProductModel> = new EventEmitter<SaleProductModel>();

    constructor(public deleteService: SaleDeleteProductActionService,
                private dialogController: DialogController) {
    }

    ngOnInit() {
    }

    buildDeletePayload = (): SaleDeleteProductActionPayload => {
        return Object.assign(new SaleDeleteProductActionPayload(), {
            saleId: this.saleId,
            saleProductId: this.entity.summary.id
        });
    };

    productDeleted() {
        this.productDeletedEvent?.emit(this.entity);
    }

    editPrice() {
        const input: ProductUpdatePriceDialogInput = {
            saleId: this.saleId,
            entity: this.entity,
        }
        this.dialogController.open(SaleProductUpdatePriceDialogComponent, input, {
            title: 'Modifier le prix',
            width: '95%'
        }).afterClosed()
            .toPromise()
            .then((output: ProductUpdatePriceDialogOutput) => {
                if (output) {
                    this.entity.summary = output.entity;
                }
            });
    }

}
